export default function scrollToTop() {
  const element = document.querySelector<HTMLElement>('.scape-sdk');

  if (element) {
    window.scrollTo({
      top: element.offsetTop,
      behavior: 'smooth',
    });
  }
}
